/**
 * Edit the lists below to change the variable names that are used for variable-URLs.
 * Unlike other content, the variable names are *not* taken from the JSON files.
 * Otherwise, we would have to download all JSON files to show the list of variables, which would be abysimally slow.
 */

const gemGlobalJsons = {
  //properly ordered for the "Select Variables" droplist:
  "GCCIv2/GEM_GLO/GCCI-GEM_GLO_IV_GCCIClimActionPerfIndex_Annual_Percent_public.json":
    "GCCI Climate Action Performance Index",
  "GCCIv2/GEM_GLO/GCCI-GEM_GLO_IV_CO2EmsChangeIndex_Annual_Percent_public.json":
    "CO2 emissions change since 1990",
  "GCCIv2/GEM_GLO/GCCI-GEM_GLO_IV_GHGEmsChangeIndex_Annual_Percent_public.json":
    "GHG emissions change since 1990",
  "GCCIv2/GEM_GLO/GCCI-GEM_GLO_PV_CO2Emissions_Annual_MtCO2_public.json":
    "CO2 annual emissions",
  "GCCIv2/GEM_GLO/GCCI-GEM_GLO_PV_GHGEmissions_Annual_MtCO2eq_public.json":
    "GHG annual emissions",
  "GCCIv2/GEM_GLO/GCCI-GEM_GLO_DV_CO2EmissionspPers_Annual_tCO2pPers_public.json":
    "CO2 annual emissions per person",
  "GCCIv2/GEM_GLO/GCCI-GEM_GLO_DV_GHGEmissionspPers_Annual_tCO2eqpPers_public.json":
    "GHG annual emissions per person",
  "GCCIv2/GEM_GLO/GCCI-GEM_GLO_DV_CO2EmissionspEcon_Annual_tCO2pMEuro_public.json":
    "CO2 annual emissions per GDP and PPP",
  "GCCIv2/GEM_GLO/GCCI-GEM_GLO_DV_GHGEmissionspEcon_Annual_tCO2eqpMEuro_public.json":
    "GHG annual emissions per GDP and PPP",
  "GCCIv2/GEM_GLO/GCCI-GEM_GLO_SV_Population_Annual_Mio.Persons_public.json":
    "Population size",
  "GCCIv2/GEM_GLO/GCCI-GEM_GLO_SV_EconomicData_Annual_BillE-MrdE_public.json":
    "Economic data (GDP PPP)",
  "GCCIv2/GEM_GLO/GCCI-GEM_GLO_DV_EconomicDatapPers_Annual_EURpPers_public.json":
    "Economic data (GDP PPP) per person",
}

const gemEurJsons = {
  //properly ordered for the "Select Variables" droplist:
  "GCCIv2/GEM_EUR/GCCI-GEM_EUR_IV_GCCIClimActionPerfIndex_Annual_Percent_public.json":
    "GCCI Climate Action Performance Index",
  "GCCIv2/GEM_EUR/GCCI-GEM_EUR_IV_CO2EmsChangeIndex_Annual_Percent_public.json":
    "CO2 emissions change since 1990",
  "GCCIv2/GEM_EUR/GCCI-GEM_EUR_IV_GHGEmsChangeIndex_Annual_Percent_public.json":
    "GHG emissions change since 1990",
  "GCCIv2/GEM_EUR/GCCI-GEM_EUR_PV_CO2Emissions_Annual_MtCO2_public.json":
    "CO2 annual emissions",
  "GCCIv2/GEM_EUR/GCCI-GEM_EUR_PV_GHGEmissions_Annual_MtCO2eq_public.json":
    "GHG annual emissions",
  "GCCIv2/GEM_EUR/GCCI-GEM_EUR_DV_CO2EmissionspPers_Annual_tCO2pPers_public.json":
    "CO2 annual emissions per person",
  "GCCIv2/GEM_EUR/GCCI-GEM_EUR_DV_GHGEmissionspPers_Annual_tCO2eqpPers_public.json":
    "GHG annual emissions per person",
  "GCCIv2/GEM_EUR/GCCI-GEM_EUR_DV_CO2EmissionspEcon_Annual_tCO2pMEuro_public.json":
    "CO2 annual emissions per GDP and PPP",
  "GCCIv2/GEM_EUR/GCCI-GEM_EUR_DV_GHGEmissionspEcon_Annual_tCO2eqpMEuro_public.json":
    "GHG annual emissions per GDP and PPP",
  "GCCIv2/GEM_EUR/GCCI-GEM_EUR_SV_Population_Annual_Mio.Persons_public.json":
    "Population size",
  "GCCIv2/GEM_EUR/GCCI-GEM_EUR_SV_EconomicData_Annual_BillE-MrdE_public.json":
    "Economic data (GDP PPP)",
  "GCCIv2/GEM_EUR/GCCI-GEM_EUR_DV_EconomicDatapPers_Annual_EURpPers_public.json":
    "Economic data (GDP PPP) per person",
}

const gemAutJsons = {
  //properly ordered for the "Select Variables" droplist:
  "GCCIv2/GEM_AUT/GCCI-GEM_AUT_IV_GCCIClimActionPerfIndex_Annual_Percent_public.json":
    "GCCI Climate Action Performance Index",
  "GCCIv2/GEM_AUT/GCCI-GEM_AUT_IV_CO2EmsChangeIndex_Annual_Percent_public.json":
    "CO2 emissions change since 1990",
  "GCCIv2/GEM_AUT/GCCI-GEM_AUT_IV_GHGEmsChangeIndex_Annual_Percent_public.json":
    "GHG emissions change since 1990",
  "GCCIv2/GEM_AUT/GCCI-GEM_AUT_PV_CO2Emissions_Annual_MtCO2_public.json":
    "CO2 annual emissions",
  "GCCIv2/GEM_AUT/GCCI-GEM_AUT_PV_GHGEmissions_Annual_MtCO2eq_public.json":
    "GHG annual emissions",
  "GCCIv2/GEM_AUT/GCCI-GEM_AUT_DV_CO2EmissionspPers_Annual_tCO2pPers_public.json":
    "CO2 annual emissions per person",
  "GCCIv2/GEM_AUT/GCCI-GEM_AUT_DV_GHGEmissionspPers_Annual_tCO2eqpPers_public.json":
    "GHG annual emissions per person",
  "GCCIv2/GEM_AUT/GCCI-GEM_AUT_DV_CO2EmissionspEcon_Annual_tCO2pMEuro_public.json":
    "CO2 annual emissions per GDP and PPP",
  "GCCIv2/GEM_AUT/GCCI-GEM_AUT_DV_GHGEmissionspEcon_Annual_tCO2eqpMEuro_public.json":
    "GHG annual emissions per GDP and PPP",
  "GCCIv2/GEM_AUT/GCCI-GEM_AUT_SV_Population_Annual_Mio.Persons_public.json":
    "Population size",
  "GCCIv2/GEM_AUT/GCCI-GEM_AUT_SV_EconomicData_Annual_BillE-MrdE_public.json":
    "Economic data (GDP PPP)",
  "GCCIv2/GEM_AUT/GCCI-GEM_AUT_DV_EconomicDatapPers_Annual_EURpPers_public.json":
    "Economic data (GDP PPP) per person",
}

const cwmJsons = {
  //properly ordered for the "Select Variables" droplist:
  "GCCIv2/CWM_GLO/GCCI-CWM_GLO_IV_GCCIGlobWarmingAmplIndex_Annual_Percent_public.json":
    "GCCI Global Warming Amplification Index",
  "GCCIv2/CWM_GLO/GCCI-CWM_GLO_PV_AHCIncrease_Annual_ZJperDecade_public.json":
    "Atmospheric heat content increase",
  "GCCIv2/CWM_GLO/GCCI-CWM_GLO_PV_EEU_Annual_ZJ_public.json":
    "Earth energy uptake since 1960",
  "GCCIv2/CWM_GLO/GCCI-CWM_GLO_PV_EEI_Annual_ZJperYear_public.json":
    "Earth energy imbalance",
  "GCCIv2/CWM_GLO/GCCI-CWM_GLO_DV_EEI_per_m2_Annual_Wm-2_public.json":
    "Earth energy imbalance per m2",
  "GCCIv2/CWM_GLO/GCCI-CWM_GLO_PV_GHGConcentrations_Annual_ppm_public.json":
    "GHG annual concentrations",
  "GCCIv2/CWM_GLO/GCCI-CWM_GLO_PV_ERF_Annual_ZJperYear_public.json":
    "Effective radiative forcing",
  "GCCIv2/CWM_GLO/GCCI-CWM_GLO_DV_ERF_per_m2_Annual_Wm-2_public.json":
    "Effective radiative forcing per m2",
  "GCCIv2/CWM_GLO/GCCI-CWM_GLO_PV_GlobalSurfaceTempChange_Annual_degC_public.json":
    "Global surface temperature change",
  "GCCIv2/CWM_GLO/GCCI-CWM_GLO_PV_GlobalSurfTempTrendRate_Annual_degCperDecade_public.json":
    "Global surface temperature trend rate",
  "GCCIv2/CWM_GLO/GCCI-CWM_GLO_DV_ForcingResponseImbalance_Annual_Wm-2_public.json":
    "Forcing-response-imbalance estimates",
}

const ewmAutJsons = {
  //properly ordered for the "Select Variables" droplist:
  "GCCIv3/EWM_AUT/GCCI-EWM_AUT_IV_GCCIHeatExtrAmplIndex_Annual_Percent_public.json":
    "GCCI Heat Extremity Amplification Index",
  "GCCIv3/EWM_AUT/GCCI-EWM_AUT_DV_HeatExtrAmplFactorCompMs_Annual_vs1961-90_public.json":
    "Heat extremes ampl factor compound metrics",
  "GCCIv3/EWM_AUT/GCCI-EWM_AUT_DV_HeatExtrAmplFactorBasicMs_Annual_vs1961-90_public.json":
    "Heat extremes ampl factor basic metrics",
  "GCCIv3/EWM_AUT/GCCI-EWM_AUT_DV_HHStressAmplFactorCompMs_Annual_vs1961-90_public.json":
    "Human heat stress ampl factor compound metrics",
  "GCCIv3/EWM_AUT/GCCI-EWM_AUT_DV_HHStressAmplFactorBasicMs_Annual_vs1961-90_public.json":
    "Human heat stress ampl factor basic metrics",
  "GCCIv3/EWM_AUT/GCCI-EWM_AUT_DV_HeatExtrAmplFactorCMsSPC_Annual_vs1961-90_public.json":
    "Heat extremes ampl factor comp metrics SPCUS",
  "GCCIv3/EWM_AUT/GCCI-EWM_AUT_DV_HeatExtrAmplFactorBMsSPC_Annual_vs1961-90_public.json":
    "Heat extremes ampl factor basic metrics SPCUS",
  "GCCIv3/EWM_AUT/GCCI-EWM_AUT_PV_HeatExtrEventFrequency_Annual_pYr_public.json":
    "Annual event frequency for heat extremes",
  "GCCIv3/EWM_AUT/GCCI-EWM_AUT_PV_HeatExtrEventDuration_Annual_days_public.json":
    "Avg event duration for heat extremes",
  "GCCIv3/EWM_AUT/GCCI-EWM_AUT_PV_HeatExtrExceedMagnitude_Annual_dC_public.json":
    "Avg exceedance magnitude for heat extremes",
  "GCCIv3/EWM_AUT/GCCI-EWM_AUT_PV_HeatExtrExceedArea_Annual_areals_public.json":
    "Avg exceedance area for heat extremes",
  "GCCIv3/EWM_AUT/GCCI-EWM_AUT_PV_HeatExtrAnnExceedDays_Annual_dayspYr_public.json":
    "Annual exceedance days for heat extremes",
  "GCCIv3/EWM_AUT/GCCI-EWM_AUT_PV_HeatExtrAvgEventStrength_Annual_dCdays_public.json":
    "Average event strength for heat extremes",
  "GCCIv3/EWM_AUT/GCCI-EWM_AUT_PV_HeatExtrAvgEventSeverity_Annual_arealdCdays_public.json":
    "Average event severity for heat extremes",
  "GCCIv3/EWM_AUT/GCCI-EWM_AUT_PV_HeatExtrTempEvExtremity_Annual_dCdayspYr_public.json":
    "Temporal events extremity for heat extremes",
  "GCCIv3/EWM_AUT/GCCI-EWM_AUT_PV_HeatExtrTotalEvExtremity_Annual_arealdCdayspYr_public.json":
    "Total events extremity for heat extremes",
  "GCCIv3/EWM_AUT/GCCI-EWM_AUT_PV_HHStressEventFrequency_Annual_pYr_public.json":
    "Annual event frequency for human heat stress",
  "GCCIv3/EWM_AUT/GCCI-EWM_AUT_PV_HHStressEventDuration_Annual_days_public.json":
    "Avg event duration for human heat stress",
  "GCCIv3/EWM_AUT/GCCI-EWM_AUT_PV_HHStressExceedMagnitude_Annual_dC_public.json":
    "Avg exceedance magnitude for human heat stress",
  "GCCIv3/EWM_AUT/GCCI-EWM_AUT_PV_HHStressExceedArea_Annual_areals_public.json":
    "Avg exceedance area for human heat stress",
  "GCCIv3/EWM_AUT/GCCI-EWM_AUT_PV_HHStressAnnExceedDays_Annual_dayspYr_public.json":
    "Annual exceedance days for human heat stress",
  "GCCIv3/EWM_AUT/GCCI-EWM_AUT_PV_HHStressAvgEventStrength_Annual_dCdays_public.json":
    "Average event strength for human heat stress",
  "GCCIv3/EWM_AUT/GCCI-EWM_AUT_PV_HHStressAvgEventSeverity_Annual_arealdCdays_public.json":
    "Average event severity for human heat stress",
  "GCCIv3/EWM_AUT/GCCI-EWM_AUT_PV_HHStressTempEvExtremity_Annual_dCdayspYr_public.json":
    "Temporal events extremity for human heat stress",
  "GCCIv3/EWM_AUT/GCCI-EWM_AUT_PV_HHStressTotalEvExtremity_Annual_arealdCdayspYr_public.json":
    "Total events extremity for human heat stress",
}

const ewmEurJsons = {
  //properly ordered for the "Select Variables" droplist:
  "GCCIv3/EWM_EUR/GCCI-EWM_EUR_IV_GCCIHeatExtrAmplIndex_Annual_Percent_public.json":
    "GCCI Heat Extremity Amplification Index",
  "GCCIv3/EWM_EUR/GCCI-EWM_EUR_DV_HeatExtrAmplFactorCompMs_Annual_vs1961-90_public.json":
    "Heat extremes ampl factor compound metrics",
  "GCCIv3/EWM_EUR/GCCI-EWM_EUR_DV_HeatExtrAmplFactorBasicMs_Annual_vs1961-90_public.json":
    "Heat extremes ampl factor basic metrics",
  "GCCIv3/EWM_EUR/GCCI-EWM_EUR_DV_HHStressAmplFactorCompMs_Annual_vs1961-90_public.json":
    "Human heat stress ampl factor compound metrics",
  "GCCIv3/EWM_EUR/GCCI-EWM_EUR_DV_HHStressAmplFactorBasicMs_Annual_vs1961-90_public.json":
    "Human heat stress ampl factor basic metrics",
  "GCCIv3/EWM_EUR/GCCI-EWM_EUR_PV_HeatExtrEventFrequency_Annual_pYr_public.json":
    "Annual event frequency for heat extremes",
  "GCCIv3/EWM_EUR/GCCI-EWM_EUR_PV_HeatExtrEventDuration_Annual_days_public.json":
    "Avg event duration for heat extremes",
  "GCCIv3/EWM_EUR/GCCI-EWM_EUR_PV_HeatExtrExceedMagnitude_Annual_dC_public.json":
    "Avg exceedance magnitude for heat extremes",
  "GCCIv3/EWM_EUR/GCCI-EWM_EUR_PV_HeatExtrExceedArea_Annual_areals_public.json":
    "Avg exceedance area for heat extremes",
  "GCCIv3/EWM_EUR/GCCI-EWM_EUR_PV_HeatExtrAnnExceedDays_Annual_dayspYr_public.json":
    "Annual exceedance days for heat extremes",
  "GCCIv3/EWM_EUR/GCCI-EWM_EUR_PV_HeatExtrAvgEventStrength_Annual_dCdays_public.json":
    "Average event strength for heat extremes",
  "GCCIv3/EWM_EUR/GCCI-EWM_EUR_PV_HeatExtrAvgEventSeverity_Annual_arealdCdays_public.json":
    "Average event severity for heat extremes",
  "GCCIv3/EWM_EUR/GCCI-EWM_EUR_PV_HeatExtrTempEvExtremity_Annual_dCdayspYr_public.json":
    "Temporal events extremity for heat extremes",
  "GCCIv3/EWM_EUR/GCCI-EWM_EUR_PV_HeatExtrTotalEvExtremity_Annual_arealdCdayspYr_public.json":
    "Total events extremity for heat extremes",
  "GCCIv3/EWM_EUR/GCCI-EWM_EUR_PV_HHStressEventFrequency_Annual_pYr_public.json":
    "Annual event frequency for human heat stress",
  "GCCIv3/EWM_EUR/GCCI-EWM_EUR_PV_HHStressEventDuration_Annual_days_public.json":
    "Avg event duration for human heat stress",
  "GCCIv3/EWM_EUR/GCCI-EWM_EUR_PV_HHStressExceedMagnitude_Annual_dC_public.json":
    "Avg exceedance magnitude for human heat stress",
  "GCCIv3/EWM_EUR/GCCI-EWM_EUR_PV_HHStressExceedArea_Annual_areals_public.json":
    "Avg exceedance area for human heat stress",
  "GCCIv3/EWM_EUR/GCCI-EWM_EUR_PV_HHStressAnnExceedDays_Annual_dayspYr_public.json":
    "Annual exceedance days for human heat stress",
  "GCCIv3/EWM_EUR/GCCI-EWM_EUR_PV_HHStressAvgEventStrength_Annual_dCdays_public.json":
    "Average event strength for human heat stress",
  "GCCIv3/EWM_EUR/GCCI-EWM_EUR_PV_HHStressAvgEventSeverity_Annual_arealdCdays_public.json":
    "Average event severity for human heat stress",
  "GCCIv3/EWM_EUR/GCCI-EWM_EUR_PV_HHStressTempEvExtremity_Annual_dCdayspYr_public.json":
    "Temporal events extremity for human heat stress",
  "GCCIv3/EWM_EUR/GCCI-EWM_EUR_PV_HHStressTotalEvExtremity_Annual_arealdCdayspYr_public.json":
    "Total events extremity for human heat stress",
}

const ewmGlobalJsons = {
  // EWM Global is a placeholder page with no data variables
}

module.exports = {
  gemGlobalJsons,
  gemEurJsons,
  gemAutJsons,
  cwmJsons,
  ewmAutJsons,
  ewmEurJsons,
  ewmGlobalJsons,
}
